/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import InstitutesSettingsRouteLinkItem from './InstitutesSettingsRouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.institutes.form-submissions'},
});

const FormSubmissionsItem = () => (
  <InstitutesSettingsRouteLinkItem
    route="midas/settings/institutes/form-submissions"
    title={messages.title}
  />
);

export default FormSubmissionsItem;
